/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".auto-width[_ngcontent-%COMP%]{width:unset!important;max-width:unset!important;min-width:unset!important}\n/*# sourceMappingURL=confirm-leave.component.css.map*/"];
export { styles as styles };
